import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useReducer,
  useState,
} from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CardContent from "@material-ui/core/CardContent";
import { useHistory } from "react-router-dom";
import { AxiosResponse } from "axios";
import Button from "../customhtmlcomponents/Button";
import { URLS } from "../../utility/UrlConstants";
import { jwtDecode } from 'jwt-decode';  

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardHeader: {
      display: "flex",
      flexWrap: "wrap",
    },
    Link: {
      fontSize: 14,
      display: "block",
      textAlign: "center",
      color: "#033076",
    },
  })
);
//state type
type State = {
  username: string;
  password: string;
  isButtonDisabled: boolean;
  helperText: string;
  isError: boolean;
  isProcessing: boolean;
};

const initialState: State = {
  username: "",
  password: "",
  isButtonDisabled: true,
  helperText: "",
  isError: false,
  isProcessing: false,
};

type Action =
  | { type: "setUsername"; payload: string }
  | { type: "setPassword"; payload: string }
  | { type: "setIsButtonDisabled"; payload: boolean }
  | { type: "loginSuccess"; payload: string }
  | { type: "loginFailed"; payload: string }
  | { type: "setIsError"; payload: boolean }
  | { type: "setIsProcessing"; payload: boolean }
  |  {type: "loginDisabled"; payload: string };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "setUsername":
      return {
        ...state,
        username: action.payload,
      };
    case "setPassword":
      return {
        ...state,
        password: action.payload,
      };
    case "setIsButtonDisabled":
      return {
        ...state,
        isButtonDisabled: action.payload,
      };
    case "setIsProcessing":
      return {
        ...state,
        isProcessing: action.payload,
      };
    case "loginSuccess":
      return {
        ...state,
        helperText: action.payload,
        isError: false,
      };
    case "loginFailed":
      return {
        ...state,
        helperText: action.payload,
        isError: true,
      };
    case "setIsError":
      return {
        ...state,
        isError: action.payload,
      };
    case "loginDisabled":
      return {
      ...state,
        isError: true,
        helperText: action.payload
      }
  }

};
export type Dispatcher<S> = Dispatch<SetStateAction<S>>;

interface ILoginProps {
  setToken?: any | Dispatcher<string>;
  setUser?: any | Dispatcher<string>;
  setCurrentForeningReportNumber: Dispatcher<number>;
}

const axios = require("axios").default;

const Login: FC<ILoginProps> = ({
  setUser,
  setToken,
  setCurrentForeningReportNumber,
}: ILoginProps) => {
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (state.username.trim() && state.password.trim()) {
      dispatch({
        type: "setIsButtonDisabled",
        payload: false,
      });
    } else {
      dispatch({
        type: "setIsButtonDisabled",
        payload: true,
      });
    }
  }, [state.username, state.password]);

  const history = useHistory();
  const handleLogin = (event: any, currentState: State) => {
    setProcessing(true);
    event.preventDefault();
    //TODO - selge inn timer for å gi admin knapp i panelet for å selv styre dette. NKS ville ikke kjøpe dette høst 2021.

    //Kommenter inn/ut if sjekken for å gjøre det skru av rapportering
      if (currentState.username !== "1") {dispatch({
        type: "loginFailed",
        payload: "Rapportering er stengt, ta kontakt med administrasjon",
      });
        setProcessing(false)
      return
      }

    axios
      .post(URLS.LOGIN_POST, {
        username: currentState.username,
        password: currentState.password,
      })
      .then(function (response: AxiosResponse) {
        try {
          // If success, direct to either adminpanel or organization's report based on role
          if (setToken !== null) {
            setToken(response.headers.authorization);
          }
          if (response.status === 200) {
            const foreningsNummer = parseInt(currentState.username);

            const token = response.headers.authorization;
            const decodedToken  = jwtDecode(token);
            const scopes = (decodedToken as {scopes: string[]}).scopes ?? [];
            setUser(currentState.username, scopes);
            console.log("Login", currentState.username, scopes)

            if(scopes.includes("ROLE_ADMIN")) {
              history.push({
                pathname: "/adminpanel",
                state: foreningsNummer,
              })
            }
            else if(scopes.includes("ROLE_VIEWER")) {
              history.push({
                pathname: "/adminpanel",
                state: foreningsNummer,
              })
            }
            else {
              setCurrentForeningReportNumber(foreningsNummer);
              history.push({
                    pathname: "/lokalforening",
                    state: foreningsNummer,
                  });  
            }
          }
        } catch (e) {
          alert(e.message);
        }
      })
      .catch(function (error: Error) {
        console.log(error);
        dispatch({
          type: "loginFailed",
          payload: "Feil foreningsnummer eller passord",
        });
      })
      .then(function () {
        setProcessing(false);
      });
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.keyCode === 13 || event.which === 13) {
      state.isButtonDisabled || handleLogin(event, state);
    }
  };

  const handleUsernameChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setUsername",
      payload: event.target.value,
    });
    dispatch({ type: "loginFailed", payload: "" });
    dispatch({ type: "setIsError", payload: false });
  };

  const handlePasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setPassword",
      payload: event.target.value,
    });
    dispatch({ type: "loginFailed", payload: "" });
    dispatch({ type: "setIsError", payload: false });
  };
  return (
    <>
      <form
        className="flex max-w-sm justify-center m-auto"
        noValidate
        autoComplete="off"
      >
        <div className="bg-sk-button-selected mt-0.5 mb-1.5 border-2 border-sk-secondary-blue rounded-md shadow-2xl p-5 justify-center">
          <CardContent>
            <div>
              <TextField
                error={state.isError}
                fullWidth
                id="username"
                data-testid="username"
                type="email"
                label="Foreningsnummer"
                placeholder="Foreningsnummer"
                margin="normal"
                color="primary"
                onChange={handleUsernameChange}
                onKeyPress={handleKeyPress}
              />
              <TextField
                error={state.isError}
                fullWidth
                id="password"
                data-testid="password"
                type="password"
                label="Passord"
                placeholder="Passord"
                margin="normal"
                helperText={state.helperText}
                onChange={handlePasswordChange}
                onKeyPress={handleKeyPress}
              />
            </div>
          </CardContent>
          <div className="">
            <Button
              type="submit"
              className={`${
                processing ? "hover:opacity-100 hover:cursor-not-allowed" : null
              } flex text-xl mx-auto mt-1 mb-4 bg-sk-primary-blue disabled:bg-gray-400 disabled:text-sk-button-unselected`}
              disabled={processing ? true : undefined}
              onClick={(e) => handleLogin(e, state)}
            >
              Logg inn
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};
export default Login;
